import { DepotsTable } from "@/features/depots/depots-table";

const DepotsScreen = () => {
  return (
    <div className="p-4">
      <DepotsTable />
    </div>
  );
};

export default DepotsScreen;
